"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _slateReact = require("slate-react");
var _styles = require("./styles");
var _LinkForm = _interopRequireDefault(require("./LinkForm"));
var _TextPopupWrapper = _interopRequireDefault(require("./TextPopupWrapper"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var EditIcon = function EditIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.376 11.031l-.27 2.404 2.359-.307 9.724-9.724-2.093-2.093-9.72 9.72zM10 3l2 2",
    fill: "none",
    stroke: "#919499",
    strokeWidth: "1.04"
  }));
};
EditIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 15"
};
var Link = function Link(_ref) {
  var children = _ref.children,
    attributes = _ref.attributes,
    element = _ref.element;
  var editor = (0, _slateReact.useEditor)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpenForm = _useState2[0],
    setIsOpenForm = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isOpenPopup = _useState4[0],
    setIsOpenPopup = _useState4[1];
  var toggleIsOpenForm = (0, _react.useCallback)(function () {
    setIsOpenForm(function (prevIsOpenForm) {
      return !prevIsOpenForm;
    });
  }, []);
  var toggleIsOpenPopup = (0, _react.useCallback)(function () {
    setIsOpenPopup(function (prevIsOpenPopup) {
      return !prevIsOpenPopup;
    });
  }, []);
  var handleLinkClick = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    toggleIsOpenPopup();
  });
  var handleEditClick = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    toggleIsOpenForm();
    toggleIsOpenPopup();
  }, []);
  var handleClearClick = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    var path = _slateReact.ReactEditor.findPath(editor, element);
    editor.unwrapLink({
      editor: editor,
      options: {
        at: path
      }
    });
    toggleIsOpenPopup();
  }, []);
  var handleSubmit = (0, _react.useCallback)(function (_ref2) {
    var url = _ref2.url;
    var path = _slateReact.ReactEditor.findPath(editor, element);
    editor.setLink({
      editor: editor,
      url: url,
      options: {
        at: path
      }
    });
    toggleIsOpenPopup();
  }, []);
  var url = element.url;
  return /*#__PURE__*/_react["default"].createElement(StyledLink, (0, _extends2["default"])({
    onClick: handleLinkClick,
    href: url
  }, attributes), /*#__PURE__*/_react["default"].createElement(_TextPopupWrapper["default"], {
    element: element,
    editor: editor,
    isOpen: isOpenPopup,
    onClose: toggleIsOpenPopup
  }, /*#__PURE__*/_react["default"].createElement(StyledLinkPopup, null, /*#__PURE__*/_react["default"].createElement(StyledLink, {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, url), /*#__PURE__*/_react["default"].createElement(StyledPopupControl, null, /*#__PURE__*/_react["default"].createElement(StyledPopupEdit, {
    onClick: handleEditClick
  }), /*#__PURE__*/_react["default"].createElement(_styles.StyledTextButton, {
    onClick: handleClearClick
  }, "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443")))), /*#__PURE__*/_react["default"].createElement(_styles.StyledPopup, {
    isOpen: isOpenForm
  }, isOpenForm && /*#__PURE__*/_react["default"].createElement(_LinkForm["default"], {
    defaultUrl: url,
    onSubmit: handleSubmit,
    onClose: toggleIsOpenForm
  })), children);
};
Link.propTypes = {
  children: _propTypes["default"].node,
  attributes: _propTypes["default"].elementType,
  element: _propTypes["default"].shape({
    url: _propTypes["default"].string
  }).isRequired
};
Link.defaultProps = {
  children: null,
  attributes: []
};
var StyledLink = _styledComponents["default"].a.withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-1nr46r2-0"
})(["display:inline;max-width:300px;position:relative;font-family:'ONYOneFont','Helvetica',sans-serif;font-size:14px;line-height:17px;color:#007aff;text-overflow:ellipsis;"]);
var StyledLinkPopup = _styledComponents["default"].span.withConfig({
  displayName: "Link__StyledLinkPopup",
  componentId: "sc-1nr46r2-1"
})(["display:flex;flex-direction:column;cursor:default;flex-wrap:wrap;background:white;border-radius:5px;padding:3px 10px 6px 10px;top:calc(100% - 70px);z-index:100;box-shadow:0 10px 15px 0 rgba(196,194,182,0.9),0 1px 2px 0 rgba(210,208,197,0.9);a{cursor:pointer;overflow:hidden;}"]);
var StyledPopupEdit = (0, _styledComponents["default"])(EditIcon).withConfig({
  displayName: "Link__StyledPopupEdit",
  componentId: "sc-1nr46r2-2"
})(["width:17px;height:17px;cursor:pointer;padding:3px 0 0 3px;position:relative;top:2px;path{stroke:#007aff;}"]);
var StyledPopupControl = _styledComponents["default"].span.withConfig({
  displayName: "Link__StyledPopupControl",
  componentId: "sc-1nr46r2-3"
})(["white-space:nowrap;"]);
var _default = exports["default"] = Link;